import styled from "styled-components";
import { Flex } from "../../../components/layout";

const Wrapper = styled.div`
  text-align: center;
  margin-top: 4em;
`;

export const NoLaunchConfigurations = () => (
  <Flex center>
    <Wrapper>
      <p>No Launch Configuration Entries</p>
    </Wrapper>
  </Flex>
);

export const AnErrorHasOccured = () => (
  <Flex center>
    <Wrapper>
      <p>An error has occured :(</p>
    </Wrapper>
  </Flex>
);
